module.exports = __webpack_public_path__ + "img/cobbl1.cc671efb.jpg";